import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface MultipleFieldState {
  type: "multiple";
  fieldName: string;
  selected: string[];
}

export interface DistanceFieldState {
  type: "distance";
  fieldName: "distance";
  selected: number;
}

export type FieldState = MultipleFieldState | DistanceFieldState;

export interface FilterByFieldName {
  [key: string]: FieldState;
}

export interface FilterSliceState {
  byFieldName: FilterByFieldName;
  draft: FilterByFieldName;
}

const initialState: FilterSliceState = {
  byFieldName: {},
  draft: {},
};

const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    setFilterField(state, action: PayloadAction<FieldState>) {
      const { payload } = action;
      state.draft[payload.fieldName] = payload;
    },
    removeFilterField(state, action: PayloadAction<{ fieldName: string }>) {
      delete state.draft[action.payload.fieldName];
    },
    applyFilters(state) {
      state.byFieldName = state.draft;
    },
    discardDraft(state) {
      state.draft = state.byFieldName;
    },
    clearFilters(state) {
      state.draft = {};
    },
  },
});

const { reducer } = filterSlice;

export const {
  setFilterField,
  removeFilterField,
  applyFilters,
  discardDraft,
  clearFilters,
} = filterSlice.actions;

export default reducer;
